var Hi = Object.defineProperty;
var Ji = (e, t, n) => t in e ? Hi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var S = (e, t, n) => Ji(e, typeof t != "symbol" ? t + "" : t, n);
import Ar from "react";
import Zi from "react-dom";
var lr = { exports: {} }, Qe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var un;
function Qi() {
  if (un) return Qe;
  un = 1;
  var e = Ar, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(u, c, f) {
    var l, _ = {}, b = null, j = null;
    f !== void 0 && (b = "" + f), c.key !== void 0 && (b = "" + c.key), c.ref !== void 0 && (j = c.ref);
    for (l in c) r.call(c, l) && !o.hasOwnProperty(l) && (_[l] = c[l]);
    if (u && u.defaultProps) for (l in c = u.defaultProps, c) _[l] === void 0 && (_[l] = c[l]);
    return { $$typeof: t, type: u, key: b, ref: j, props: _, _owner: i.current };
  }
  return Qe.Fragment = n, Qe.jsx = a, Qe.jsxs = a, Qe;
}
var et = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cn;
function eo() {
  return cn || (cn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ar, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), j = Symbol.for("react.offscreen"), x = Symbol.iterator, I = "@@iterator";
    function M(s) {
      if (s === null || typeof s != "object")
        return null;
      var d = x && s[x] || s[I];
      return typeof d == "function" ? d : null;
    }
    var L = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function D(s) {
      {
        for (var d = arguments.length, h = new Array(d > 1 ? d - 1 : 0), m = 1; m < d; m++)
          h[m - 1] = arguments[m];
        je("error", s, h);
      }
    }
    function je(s, d, h) {
      {
        var m = L.ReactDebugCurrentFrame, A = m.getStackAddendum();
        A !== "" && (d += "%s", h = h.concat([A]));
        var w = h.map(function(O) {
          return String(O);
        });
        w.unshift("Warning: " + d), Function.prototype.apply.call(console[s], console, w);
      }
    }
    var k = !1, ce = !1, he = !1, ht = !1, Ei = !1, Lr;
    Lr = Symbol.for("react.module.reference");
    function Ai(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === r || s === o || Ei || s === i || s === f || s === l || ht || s === j || k || ce || he || typeof s == "object" && s !== null && (s.$$typeof === b || s.$$typeof === _ || s.$$typeof === a || s.$$typeof === u || s.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === Lr || s.getModuleId !== void 0));
    }
    function wi(s, d, h) {
      var m = s.displayName;
      if (m)
        return m;
      var A = d.displayName || d.name || "";
      return A !== "" ? h + "(" + A + ")" : h;
    }
    function Br(s) {
      return s.displayName || "Context";
    }
    function _e(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && D("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case f:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case u:
            var d = s;
            return Br(d) + ".Consumer";
          case a:
            var h = s;
            return Br(h._context) + ".Provider";
          case c:
            return wi(s, s.render, "ForwardRef");
          case _:
            var m = s.displayName || null;
            return m !== null ? m : _e(s.type) || "Memo";
          case b: {
            var A = s, w = A._payload, O = A._init;
            try {
              return _e(O(w));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Pe = Object.assign, Je = 0, kr, Fr, Ur, $r, Kr, Gr, Wr;
    function qr() {
    }
    qr.__reactDisabledLog = !0;
    function Ni() {
      {
        if (Je === 0) {
          kr = console.log, Fr = console.info, Ur = console.warn, $r = console.error, Kr = console.group, Gr = console.groupCollapsed, Wr = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: qr,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        Je++;
      }
    }
    function Di() {
      {
        if (Je--, Je === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Pe({}, s, {
              value: kr
            }),
            info: Pe({}, s, {
              value: Fr
            }),
            warn: Pe({}, s, {
              value: Ur
            }),
            error: Pe({}, s, {
              value: $r
            }),
            group: Pe({}, s, {
              value: Kr
            }),
            groupCollapsed: Pe({}, s, {
              value: Gr
            }),
            groupEnd: Pe({}, s, {
              value: Wr
            })
          });
        }
        Je < 0 && D("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ht = L.ReactCurrentDispatcher, Jt;
    function _t(s, d, h) {
      {
        if (Jt === void 0)
          try {
            throw Error();
          } catch (A) {
            var m = A.stack.trim().match(/\n( *(at )?)/);
            Jt = m && m[1] || "";
          }
        return `
` + Jt + s;
      }
    }
    var Zt = !1, bt;
    {
      var Si = typeof WeakMap == "function" ? WeakMap : Map;
      bt = new Si();
    }
    function zr(s, d) {
      if (!s || Zt)
        return "";
      {
        var h = bt.get(s);
        if (h !== void 0)
          return h;
      }
      var m;
      Zt = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var w;
      w = Ht.current, Ht.current = null, Ni();
      try {
        if (d) {
          var O = function() {
            throw Error();
          };
          if (Object.defineProperty(O.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(O, []);
            } catch (be) {
              m = be;
            }
            Reflect.construct(s, [], O);
          } else {
            try {
              O.call();
            } catch (be) {
              m = be;
            }
            s.call(O.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (be) {
            m = be;
          }
          s();
        }
      } catch (be) {
        if (be && m && typeof be.stack == "string") {
          for (var y = be.stack.split(`
`), F = m.stack.split(`
`), R = y.length - 1, T = F.length - 1; R >= 1 && T >= 0 && y[R] !== F[T]; )
            T--;
          for (; R >= 1 && T >= 0; R--, T--)
            if (y[R] !== F[T]) {
              if (R !== 1 || T !== 1)
                do
                  if (R--, T--, T < 0 || y[R] !== F[T]) {
                    var z = `
` + y[R].replace(" at new ", " at ");
                    return s.displayName && z.includes("<anonymous>") && (z = z.replace("<anonymous>", s.displayName)), typeof s == "function" && bt.set(s, z), z;
                  }
                while (R >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        Zt = !1, Ht.current = w, Di(), Error.prepareStackTrace = A;
      }
      var Fe = s ? s.displayName || s.name : "", sn = Fe ? _t(Fe) : "";
      return typeof s == "function" && bt.set(s, sn), sn;
    }
    function ji(s, d, h) {
      return zr(s, !1);
    }
    function Pi(s) {
      var d = s.prototype;
      return !!(d && d.isReactComponent);
    }
    function gt(s, d, h) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return zr(s, Pi(s));
      if (typeof s == "string")
        return _t(s);
      switch (s) {
        case f:
          return _t("Suspense");
        case l:
          return _t("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case c:
            return ji(s.render);
          case _:
            return gt(s.type, d, h);
          case b: {
            var m = s, A = m._payload, w = m._init;
            try {
              return gt(w(A), d, h);
            } catch {
            }
          }
        }
      return "";
    }
    var mt = Object.prototype.hasOwnProperty, Yr = {}, Xr = L.ReactDebugCurrentFrame;
    function yt(s) {
      if (s) {
        var d = s._owner, h = gt(s.type, s._source, d ? d.type : null);
        Xr.setExtraStackFrame(h);
      } else
        Xr.setExtraStackFrame(null);
    }
    function Vi(s, d, h, m, A) {
      {
        var w = Function.call.bind(mt);
        for (var O in s)
          if (w(s, O)) {
            var y = void 0;
            try {
              if (typeof s[O] != "function") {
                var F = Error((m || "React class") + ": " + h + " type `" + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[O] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw F.name = "Invariant Violation", F;
              }
              y = s[O](d, O, m, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (R) {
              y = R;
            }
            y && !(y instanceof Error) && (yt(A), D("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", h, O, typeof y), yt(null)), y instanceof Error && !(y.message in Yr) && (Yr[y.message] = !0, yt(A), D("Failed %s type: %s", h, y.message), yt(null));
          }
      }
    }
    var Ri = Array.isArray;
    function Qt(s) {
      return Ri(s);
    }
    function xi(s) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, h = d && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return h;
      }
    }
    function Ti(s) {
      try {
        return Hr(s), !1;
      } catch {
        return !0;
      }
    }
    function Hr(s) {
      return "" + s;
    }
    function Jr(s) {
      if (Ti(s))
        return D("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", xi(s)), Hr(s);
    }
    var Ze = L.ReactCurrentOwner, Ci = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Zr, Qr, er;
    er = {};
    function Mi(s) {
      if (mt.call(s, "ref")) {
        var d = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function Ii(s) {
      if (mt.call(s, "key")) {
        var d = Object.getOwnPropertyDescriptor(s, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function Li(s, d) {
      if (typeof s.ref == "string" && Ze.current && d && Ze.current.stateNode !== d) {
        var h = _e(Ze.current.type);
        er[h] || (D('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _e(Ze.current.type), s.ref), er[h] = !0);
      }
    }
    function Bi(s, d) {
      {
        var h = function() {
          Zr || (Zr = !0, D("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        h.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: h,
          configurable: !0
        });
      }
    }
    function ki(s, d) {
      {
        var h = function() {
          Qr || (Qr = !0, D("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        h.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: h,
          configurable: !0
        });
      }
    }
    var Fi = function(s, d, h, m, A, w, O) {
      var y = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: s,
        key: d,
        ref: h,
        props: O,
        // Record the component responsible for creating this element.
        _owner: w
      };
      return y._store = {}, Object.defineProperty(y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(y, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(y, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(y.props), Object.freeze(y)), y;
    };
    function Ui(s, d, h, m, A) {
      {
        var w, O = {}, y = null, F = null;
        h !== void 0 && (Jr(h), y = "" + h), Ii(d) && (Jr(d.key), y = "" + d.key), Mi(d) && (F = d.ref, Li(d, A));
        for (w in d)
          mt.call(d, w) && !Ci.hasOwnProperty(w) && (O[w] = d[w]);
        if (s && s.defaultProps) {
          var R = s.defaultProps;
          for (w in R)
            O[w] === void 0 && (O[w] = R[w]);
        }
        if (y || F) {
          var T = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          y && Bi(O, T), F && ki(O, T);
        }
        return Fi(s, y, F, A, m, Ze.current, O);
      }
    }
    var tr = L.ReactCurrentOwner, en = L.ReactDebugCurrentFrame;
    function ke(s) {
      if (s) {
        var d = s._owner, h = gt(s.type, s._source, d ? d.type : null);
        en.setExtraStackFrame(h);
      } else
        en.setExtraStackFrame(null);
    }
    var rr;
    rr = !1;
    function nr(s) {
      return typeof s == "object" && s !== null && s.$$typeof === t;
    }
    function tn() {
      {
        if (tr.current) {
          var s = _e(tr.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function $i(s) {
      return "";
    }
    var rn = {};
    function Ki(s) {
      {
        var d = tn();
        if (!d) {
          var h = typeof s == "string" ? s : s.displayName || s.name;
          h && (d = `

Check the top-level render call using <` + h + ">.");
        }
        return d;
      }
    }
    function nn(s, d) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var h = Ki(d);
        if (rn[h])
          return;
        rn[h] = !0;
        var m = "";
        s && s._owner && s._owner !== tr.current && (m = " It was passed a child from " + _e(s._owner.type) + "."), ke(s), D('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', h, m), ke(null);
      }
    }
    function on(s, d) {
      {
        if (typeof s != "object")
          return;
        if (Qt(s))
          for (var h = 0; h < s.length; h++) {
            var m = s[h];
            nr(m) && nn(m, d);
          }
        else if (nr(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var A = M(s);
          if (typeof A == "function" && A !== s.entries)
            for (var w = A.call(s), O; !(O = w.next()).done; )
              nr(O.value) && nn(O.value, d);
        }
      }
    }
    function Gi(s) {
      {
        var d = s.type;
        if (d == null || typeof d == "string")
          return;
        var h;
        if (typeof d == "function")
          h = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === _))
          h = d.propTypes;
        else
          return;
        if (h) {
          var m = _e(d);
          Vi(h, s.props, "prop", m, s);
        } else if (d.PropTypes !== void 0 && !rr) {
          rr = !0;
          var A = _e(d);
          D("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && D("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Wi(s) {
      {
        for (var d = Object.keys(s.props), h = 0; h < d.length; h++) {
          var m = d[h];
          if (m !== "children" && m !== "key") {
            ke(s), D("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ke(null);
            break;
          }
        }
        s.ref !== null && (ke(s), D("Invalid attribute `ref` supplied to `React.Fragment`."), ke(null));
      }
    }
    function an(s, d, h, m, A, w) {
      {
        var O = Ai(s);
        if (!O) {
          var y = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var F = $i();
          F ? y += F : y += tn();
          var R;
          s === null ? R = "null" : Qt(s) ? R = "array" : s !== void 0 && s.$$typeof === t ? (R = "<" + (_e(s.type) || "Unknown") + " />", y = " Did you accidentally export a JSX literal instead of a component?") : R = typeof s, D("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, y);
        }
        var T = Ui(s, d, h, A, w);
        if (T == null)
          return T;
        if (O) {
          var z = d.children;
          if (z !== void 0)
            if (m)
              if (Qt(z)) {
                for (var Fe = 0; Fe < z.length; Fe++)
                  on(z[Fe], s);
                Object.freeze && Object.freeze(z);
              } else
                D("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              on(z, s);
        }
        return s === r ? Wi(T) : Gi(T), T;
      }
    }
    function qi(s, d, h) {
      return an(s, d, h, !0);
    }
    function zi(s, d, h) {
      return an(s, d, h, !1);
    }
    var Yi = zi, Xi = qi;
    et.Fragment = r, et.jsx = Yi, et.jsxs = Xi;
  }()), et;
}
process.env.NODE_ENV === "production" ? lr.exports = Qi() : lr.exports = eo();
var nt = lr.exports;
class to extends Ar.Component {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t, n) {
    this.props.logError({
      ...t,
      ...n,
      statusCode: "WidgetsCoreErrorBoundary",
      description: "Error while trying to render React component"
    });
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ nt.jsx(nt.Fragment, {}) : this.props.children;
  }
}
var ro = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, n) {
    return "Cannot apply '" + t + "' to '" + n.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, n) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + n;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, n) {
    return "the entry '" + t + "' does not exist in the observable map '" + n + "'";
  },
  26: "please specify a property",
  27: function(t, n) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + n + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, n) {
    return "Cycle detected in computation " + t + ": " + n;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, no = process.env.NODE_ENV !== "production" ? ro : {};
function p(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof e == "string" ? e : no[e];
    throw typeof i == "function" && (i = i.apply(null, n)), new Error("[MobX] " + i);
  }
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var io = {};
function wr() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : io;
}
var Vn = Object.assign, Dt = Object.getOwnPropertyDescriptor, fe = Object.defineProperty, kt = Object.prototype, St = [];
Object.freeze(St);
var Nr = {};
Object.freeze(Nr);
var oo = typeof Proxy < "u", ao = /* @__PURE__ */ Object.toString();
function Rn() {
  oo || p(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function tt(e) {
  process.env.NODE_ENV !== "production" && v.verifyProxies && p("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + e);
}
function te() {
  return ++v.mobxGuid;
}
function Dr(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var Ue = function() {
};
function V(e) {
  return typeof e == "function";
}
function Ne(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Ft(e) {
  return e !== null && typeof e == "object";
}
function se(e) {
  if (!Ft(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === ao;
}
function xn(e) {
  var t = e == null ? void 0 : e.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Ut(e, t, n) {
  fe(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function Tn(e, t, n) {
  fe(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function Ie(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return Ft(r) && r[n] === !0;
  };
}
function qe(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function so(e) {
  var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t), r = Object.getPrototypeOf(n);
  return r === null;
}
function ge(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var Cn = typeof Object.getOwnPropertySymbols < "u";
function uo(e) {
  var t = Object.keys(e);
  if (!Cn)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return kt.propertyIsEnumerable.call(e, r);
  })) : t;
}
var $t = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Cn ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function fr(e) {
  return typeof e == "string" ? e : typeof e == "symbol" ? e.toString() : new String(e).toString();
}
function Mn(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Z(e, t) {
  return kt.hasOwnProperty.call(e, t);
}
var co = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return $t(t).forEach(function(r) {
    n[r] = Dt(t, r);
  }), n;
};
function $(e, t) {
  return !!(e & t);
}
function K(e, t, n) {
  return n ? e |= t : e &= ~t, e;
}
function ln(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function lo(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, vo(r.key), r);
  }
}
function ze(e, t, n) {
  return t && lo(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function $e(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = po(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ye.apply(null, arguments);
}
function In(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, dr(e, t);
}
function dr(e, t) {
  return dr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, dr(e, t);
}
function fo(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function vo(e) {
  var t = fo(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function po(e, t) {
  if (e) {
    if (typeof e == "string") return ln(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ln(e, t) : void 0;
  }
}
var U = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function de(e) {
  function t(n, r) {
    if (lt(r))
      return e.decorate_20223_(n, r);
    ct(n, r, e);
  }
  return Object.assign(t, e);
}
function ct(e, t, n) {
  if (Z(e, U) || Ut(e, U, ye({}, e[U])), process.env.NODE_ENV !== "production" && jt(n) && !Z(e[U], t)) {
    var r = e.constructor.name + ".prototype." + t.toString();
    p("'" + r + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  ho(e, n, t), jt(n) || (e[U][t] = n);
}
function ho(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !jt(t) && Z(e[U], n)) {
    var r = e.constructor.name + ".prototype." + n.toString(), i = e[U][n].annotationType_, o = t.annotationType_;
    p("Cannot apply '@" + o + "' to '" + r + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function _o(e) {
  return Z(e, U) || Ut(e, U, ye({}, e[U])), e[U];
}
function lt(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
function Kt(e, t) {
  process.env.NODE_ENV !== "production" && !t.includes(e.kind) && p("The decorator applied to '" + String(e.name) + "' cannot be used on a " + e.kind + " element");
}
var g = /* @__PURE__ */ Symbol("mobx administration"), De = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Atom@" + te() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = E.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return Qn(this);
  }, t.reportChanged = function() {
    H(), ei(this), J();
  }, t.toString = function() {
    return this.name_;
  }, ze(e, [{
    key: "isBeingObserved",
    get: function() {
      return $(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return $(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return $(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
De.isBeingObservedMask_ = 1;
De.isPendingUnobservationMask_ = 2;
De.diffValueMask_ = 4;
var Sr = /* @__PURE__ */ Ie("Atom", De);
function Ln(e, t, n) {
  t === void 0 && (t = Ue), n === void 0 && (n = Ue);
  var r = new De(e);
  return t !== Ue && ci(r, t), n !== Ue && dt(r, n), r;
}
function bo(e, t) {
  return e === t;
}
function go(e, t) {
  return Cr(e, t);
}
function mo(e, t) {
  return Cr(e, t, 1);
}
function yo(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var Ke = {
  identity: bo,
  structural: go,
  default: yo,
  shallow: mo
};
function xe(e, t, n) {
  return st(e) ? e : Array.isArray(e) ? P.array(e, {
    name: n
  }) : se(e) ? P.object(e, void 0, {
    name: n
  }) : qe(e) ? P.map(e, {
    name: n
  }) : ge(e) ? P.set(e, {
    name: n
  }) : typeof e == "function" && !Me(e) && !at(e) ? xn(e) ? We(e) : ot(n, e) : e;
}
function Oo(e, t, n) {
  if (e == null || Se(e) || Ye(e) || pe(e) || ne(e))
    return e;
  if (Array.isArray(e))
    return P.array(e, {
      name: n,
      deep: !1
    });
  if (se(e))
    return P.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (qe(e))
    return P.map(e, {
      name: n,
      deep: !1
    });
  if (ge(e))
    return P.set(e, {
      name: n,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && p("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function Gt(e) {
  return e;
}
function Eo(e, t) {
  return process.env.NODE_ENV !== "production" && st(e) && p("observable.struct should not be used with observable values"), Cr(e, t) ? t : e;
}
var Ao = "override";
function jt(e) {
  return e.annotationType_ === Ao;
}
function ft(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: wo,
    extend_: No,
    decorate_20223_: Do
  };
}
function wo(e, t, n, r) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if (Me(n.value))
    return 1;
  var o = Bn(e, this, t, n, !1);
  return fe(r, t, o), 2;
}
function No(e, t, n, r) {
  var i = Bn(e, this, t, n);
  return e.defineProperty_(t, i, r);
}
function Do(e, t) {
  process.env.NODE_ENV !== "production" && Kt(t, ["method", "field"]);
  var n = t.kind, r = t.name, i = t.addInitializer, o = this, a = function(f) {
    var l, _, b, j;
    return Te((l = (_ = o.options_) == null ? void 0 : _.name) != null ? l : r.toString(), f, (b = (j = o.options_) == null ? void 0 : j.autoAction) != null ? b : !1);
  };
  if (n == "field")
    return function(c) {
      var f, l = c;
      return Me(l) || (l = a(l)), (f = o.options_) != null && f.bound && (l = l.bind(this), l.isMobxAction = !0), l;
    };
  if (n == "method") {
    var u;
    return Me(e) || (e = a(e)), (u = this.options_) != null && u.bound && i(function() {
      var c = this, f = c[r].bind(c);
      f.isMobxAction = !0, c[r] = f;
    }), e;
  }
  p("Cannot apply '" + o.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + (`
'` + o.annotationType_ + "' can only be used on properties with a function value."));
}
function So(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !V(o) && p("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function Bn(e, t, n, r, i) {
  var o, a, u, c, f, l, _;
  i === void 0 && (i = v.safeDescriptors), So(e, t, n, r);
  var b = r.value;
  if ((o = t.options_) != null && o.bound) {
    var j;
    b = b.bind((j = e.proxy_) != null ? j : e.target_);
  }
  return {
    value: Te(
      (a = (u = t.options_) == null ? void 0 : u.name) != null ? a : n.toString(),
      b,
      (c = (f = t.options_) == null ? void 0 : f.autoAction) != null ? c : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (l = t.options_) != null && l.bound ? (_ = e.proxy_) != null ? _ : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function kn(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: jo,
    extend_: Po,
    decorate_20223_: Vo
  };
}
function jo(e, t, n, r) {
  var i;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!Z(e.target_, t) || !at(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (at(n.value))
    return 1;
  var o = Fn(e, this, t, n, !1, !1);
  return fe(r, t, o), 2;
}
function Po(e, t, n, r) {
  var i, o = Fn(e, this, t, n, (i = this.options_) == null ? void 0 : i.bound);
  return e.defineProperty_(t, o, r);
}
function Vo(e, t) {
  var n;
  process.env.NODE_ENV !== "production" && Kt(t, ["method"]);
  var r = t.name, i = t.addInitializer;
  return at(e) || (e = We(e)), (n = this.options_) != null && n.bound && i(function() {
    var o = this, a = o[r].bind(o);
    a.isMobXFlow = !0, o[r] = a;
  }), e;
}
function Ro(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !V(o) && p("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function Fn(e, t, n, r, i, o) {
  o === void 0 && (o = v.safeDescriptors), Ro(e, t, n, r);
  var a = r.value;
  if (at(a) || (a = We(a)), i) {
    var u;
    a = a.bind((u = e.proxy_) != null ? u : e.target_), a.isMobXFlow = !0;
  }
  return {
    value: a,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: o ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !o
  };
}
function jr(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: xo,
    extend_: To,
    decorate_20223_: Co
  };
}
function xo(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function To(e, t, n, r) {
  return Mo(e, this, t, n), e.defineComputedProperty_(t, ye({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function Co(e, t) {
  process.env.NODE_ENV !== "production" && Kt(t, ["getter"]);
  var n = this, r = t.name, i = t.addInitializer;
  return i(function() {
    var o = Xe(this)[g], a = ye({}, n.options_, {
      get: e,
      context: this
    });
    a.name || (a.name = process.env.NODE_ENV !== "production" ? o.name_ + "." + r.toString() : "ObservableObject." + r.toString()), o.values_.set(r, new ee(a));
  }), function() {
    return this[g].getObservablePropValue_(r);
  };
}
function Mo(e, t, n, r) {
  var i = t.annotationType_, o = r.get;
  process.env.NODE_ENV !== "production" && !o && p("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function Wt(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Io,
    extend_: Lo,
    decorate_20223_: Bo
  };
}
function Io(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Lo(e, t, n, r) {
  var i, o;
  return ko(e, this, t, n), e.defineObservableProperty_(t, n.value, (i = (o = this.options_) == null ? void 0 : o.enhancer) != null ? i : xe, r);
}
function Bo(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (t.kind === "field")
      throw p("Please use `@observable accessor " + String(t.name) + "` instead of `@observable " + String(t.name) + "`");
    Kt(t, ["accessor"]);
  }
  var n = this, r = t.kind, i = t.name, o = /* @__PURE__ */ new WeakSet();
  function a(u, c) {
    var f, l, _ = Xe(u)[g], b = new Re(c, (f = (l = n.options_) == null ? void 0 : l.enhancer) != null ? f : xe, process.env.NODE_ENV !== "production" ? _.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    _.values_.set(i, b), o.add(u);
  }
  if (r == "accessor")
    return {
      get: function() {
        return o.has(this) || a(this, e.get.call(this)), this[g].getObservablePropValue_(i);
      },
      set: function(c) {
        return o.has(this) || a(this, c), this[g].setObservablePropValue_(i, c);
      },
      init: function(c) {
        return o.has(this) || a(this, c), c;
      }
    };
}
function ko(e, t, n, r) {
  var i = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in r) && p("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var Fo = "true", Uo = /* @__PURE__ */ Un();
function Un(e) {
  return {
    annotationType_: Fo,
    options_: e,
    make_: $o,
    extend_: Ko,
    decorate_20223_: Go
  };
}
function $o(e, t, n, r) {
  var i, o;
  if (n.get)
    return ve.make_(e, t, n, r);
  if (n.set) {
    var a = Te(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: v.safeDescriptors ? e.isPlainObject_ : !0,
      set: a
    }) === null ? 0 : 2 : (fe(r, t, {
      configurable: !0,
      set: a
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var u;
    if (xn(n.value)) {
      var c, f = (c = this.options_) != null && c.autoBind ? We.bound : We;
      return f.make_(e, t, n, r);
    }
    var l = (u = this.options_) != null && u.autoBind ? ot.bound : ot;
    return l.make_(e, t, n, r);
  }
  var _ = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? P.ref : P;
  if (typeof n.value == "function" && (o = this.options_) != null && o.autoBind) {
    var b;
    n.value = n.value.bind((b = e.proxy_) != null ? b : e.target_);
  }
  return _.make_(e, t, n, r);
}
function Ko(e, t, n, r) {
  var i, o;
  if (n.get)
    return ve.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: v.safeDescriptors ? e.isPlainObject_ : !0,
      set: Te(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (i = this.options_) != null && i.autoBind) {
    var a;
    n.value = n.value.bind((a = e.proxy_) != null ? a : e.target_);
  }
  var u = ((o = this.options_) == null ? void 0 : o.deep) === !1 ? P.ref : P;
  return u.extend_(e, t, n, r);
}
function Go(e, t) {
  p("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var Wo = "observable", qo = "observable.ref", zo = "observable.shallow", Yo = "observable.struct", $n = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze($n);
function Ot(e) {
  return e || $n;
}
var vr = /* @__PURE__ */ Wt(Wo), Xo = /* @__PURE__ */ Wt(qo, {
  enhancer: Gt
}), Ho = /* @__PURE__ */ Wt(zo, {
  enhancer: Oo
}), Jo = /* @__PURE__ */ Wt(Yo, {
  enhancer: Eo
}), Kn = /* @__PURE__ */ de(vr);
function Et(e) {
  return e.deep === !0 ? xe : e.deep === !1 ? Gt : Qo(e.defaultDecorator);
}
function Zo(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : Un(e) : void 0;
}
function Qo(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : xe;
}
function Gn(e, t, n) {
  if (lt(t))
    return vr.decorate_20223_(e, t);
  if (Ne(t)) {
    ct(e, t, vr);
    return;
  }
  return st(e) ? e : se(e) ? P.object(e, t, n) : Array.isArray(e) ? P.array(e, t) : qe(e) ? P.map(e, t) : ge(e) ? P.set(e, t) : typeof e == "object" && e !== null ? e : P.box(e, t);
}
Vn(Gn, Kn);
var ea = {
  box: function(t, n) {
    var r = Ot(n);
    return new Re(t, Et(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = Ot(n);
    return (v.useProxies === !1 || r.proxy === !1 ? rs : qa)(t, Et(r), r.name);
  },
  map: function(t, n) {
    var r = Ot(n);
    return new xr(t, Et(r), r.name);
  },
  set: function(t, n) {
    var r = Ot(n);
    return new _i(t, Et(r), r.name);
  },
  object: function(t, n, r) {
    return Be(function() {
      return fi(v.useProxies === !1 || (r == null ? void 0 : r.proxy) === !1 ? Xe({}, r) : Ka({}, r), t, n);
    });
  },
  ref: /* @__PURE__ */ de(Xo),
  shallow: /* @__PURE__ */ de(Ho),
  deep: Kn,
  struct: /* @__PURE__ */ de(Jo)
}, P = /* @__PURE__ */ Vn(Gn, ea), Wn = "computed", ta = "computed.struct", pr = /* @__PURE__ */ jr(Wn), ra = /* @__PURE__ */ jr(ta, {
  equals: Ke.structural
}), ve = function(t, n) {
  if (lt(n))
    return pr.decorate_20223_(t, n);
  if (Ne(n))
    return ct(t, n, pr);
  if (se(t))
    return de(jr(Wn, t));
  process.env.NODE_ENV !== "production" && (V(t) || p("First argument to `computed` should be an expression."), V(n) && p("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var r = se(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new ee(r);
};
Object.assign(ve, pr);
ve.struct = /* @__PURE__ */ de(ra);
var fn, dn, Pt = 0, na = 1, ia = (fn = (dn = /* @__PURE__ */ Dt(function() {
}, "name")) == null ? void 0 : dn.configurable) != null ? fn : !1, vn = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function Te(e, t, n, r) {
  n === void 0 && (n = !1), process.env.NODE_ENV !== "production" && (V(t) || p("`action` can only be invoked on functions"), (typeof e != "string" || !e) && p("actions should have valid names, got: '" + e + "'"));
  function i() {
    return qn(e, n, t, r || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return t.toString();
  }, ia && (vn.value = e, fe(i, "name", vn)), i;
}
function qn(e, t, n, r, i) {
  var o = oa(e, t, r, i);
  try {
    return n.apply(r, i);
  } catch (a) {
    throw o.error_ = a, a;
  } finally {
    aa(o);
  }
}
function oa(e, t, n, r) {
  var i = process.env.NODE_ENV !== "production" && B() && !!e, o = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    o = Date.now();
    var a = r ? Array.from(r) : St;
    G({
      type: Vr,
      name: e,
      object: n,
      arguments: a
    });
  }
  var u = v.trackingDerivation, c = !t || !u;
  H();
  var f = v.allowStateChanges;
  c && (Le(), f = qt(!0));
  var l = Pr(!0), _ = {
    runAsAction_: c,
    prevDerivation_: u,
    prevAllowStateChanges_: f,
    prevAllowStateReads_: l,
    notifySpy_: i,
    startTime_: o,
    actionId_: na++,
    parentActionId_: Pt
  };
  return Pt = _.actionId_, _;
}
function aa(e) {
  Pt !== e.actionId_ && p(30), Pt = e.parentActionId_, e.error_ !== void 0 && (v.suppressReactionErrors = !0), zt(e.prevAllowStateChanges_), it(e.prevAllowStateReads_), J(), e.runAsAction_ && me(e.prevDerivation_), process.env.NODE_ENV !== "production" && e.notifySpy_ && W({
    time: Date.now() - e.startTime_
  }), v.suppressReactionErrors = !1;
}
function sa(e, t) {
  var n = qt(e);
  try {
    return t();
  } finally {
    zt(n);
  }
}
function qt(e) {
  var t = v.allowStateChanges;
  return v.allowStateChanges = e, t;
}
function zt(e) {
  v.allowStateChanges = e;
}
var ua = "create", Re = /* @__PURE__ */ function(e) {
  function t(r, i, o, a, u) {
    var c;
    return o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableValue@" + te() : "ObservableValue"), a === void 0 && (a = !0), u === void 0 && (u = Ke.default), c = e.call(this, o) || this, c.enhancer = void 0, c.name_ = void 0, c.equals = void 0, c.hasUnreportedChange_ = !1, c.interceptors_ = void 0, c.changeListeners_ = void 0, c.value_ = void 0, c.dehancer = void 0, c.enhancer = i, c.name_ = o, c.equals = u, c.value_ = i(r, void 0, o), process.env.NODE_ENV !== "production" && a && B() && Ce({
      type: ua,
      object: c,
      observableKind: "value",
      debugObjectName: c.name_,
      newValue: "" + c.value_
    }), c;
  }
  In(t, e);
  var n = t.prototype;
  return n.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, n.set = function(i) {
    var o = this.value_;
    if (i = this.prepareNewValue_(i), i !== v.UNCHANGED) {
      var a = B();
      process.env.NODE_ENV !== "production" && a && G({
        type: ie,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: o
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && a && W();
    }
  }, n.prepareNewValue_ = function(i) {
    if (le(this), Y(this)) {
      var o = X(this, {
        object: this,
        type: ie,
        newValue: i
      });
      if (!o)
        return v.UNCHANGED;
      i = o.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? v.UNCHANGED : i;
  }, n.setNewValue_ = function(i) {
    var o = this.value_;
    this.value_ = i, this.reportChanged(), oe(this) && ae(this, {
      type: ie,
      object: this,
      newValue: i,
      oldValue: o
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(i) {
    return vt(this, i);
  }, n.observe_ = function(i, o) {
    return o && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: ie,
      newValue: this.value_,
      oldValue: void 0
    }), pt(this, i);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return Mn(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
}(De), ee = /* @__PURE__ */ function() {
  function e(n) {
    this.dependenciesState_ = E.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = E.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Vt(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Q.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || p(31), this.derivation = n.get, this.name_ = n.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + te() : "ComputedValue"), n.set && (this.setter_ = Te(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? Ke.structural : Ke.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    ha(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing && p(32, this.name_, this.derivation), v.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      hr(this) && (this.warnAboutUntrackedRead_(), H(), this.value_ = this.computeValue_(!1), J());
    else if (Qn(this), hr(this)) {
      var r = v.trackingContext;
      this.keepAlive_ && !r && (v.trackingContext = this), this.trackAndCompute() && pa(this), v.trackingContext = r;
    }
    var i = this.value_;
    if (Nt(i))
      throw i.cause;
    return i;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter && p(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      p(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === E.NOT_TRACKING_
    ), o = this.computeValue_(!0), a = i || Nt(r) || Nt(o) || !this.equals_(r, o);
    return a && (this.value_ = o, process.env.NODE_ENV !== "production" && B() && Ce({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: r,
      newValue: o
    })), a;
  }, t.computeValue_ = function(r) {
    this.isComputing = !0;
    var i = qt(!1), o;
    if (r)
      o = Yn(this, this.derivation, this.scope_);
    else if (v.disableErrorBoundaries === !0)
      o = this.derivation.call(this.scope_);
    else
      try {
        o = this.derivation.call(this.scope_);
      } catch (a) {
        o = new Vt(a);
      }
    return zt(i), this.isComputing = !1, o;
  }, t.suspend_ = function() {
    this.keepAlive_ || (_r(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== Q.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(r, i) {
    var o = this, a = !0, u = void 0;
    return wa(function() {
      var c = o.get();
      if (!a || i) {
        var f = Le();
        r({
          observableKind: "computed",
          debugObjectName: o.name_,
          type: ie,
          object: o,
          newValue: c,
          oldValue: u
        }), me(f);
      }
      a = !1, u = c;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== Q.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : v.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return Mn(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, ze(e, [{
    key: "isComputing",
    get: function() {
      return $(this.flags_, e.isComputingMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isComputingMask_, r);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return $(this.flags_, e.isRunningSetterMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isRunningSetterMask_, r);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return $(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return $(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return $(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
ee.isComputingMask_ = 1;
ee.isRunningSetterMask_ = 2;
ee.isBeingObservedMask_ = 4;
ee.isPendingUnobservationMask_ = 8;
ee.diffValueMask_ = 16;
var Ge = /* @__PURE__ */ Ie("ComputedValue", ee), E;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(E || (E = {}));
var Q;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(Q || (Q = {}));
var Vt = function(t) {
  this.cause = void 0, this.cause = t;
};
function Nt(e) {
  return e instanceof Vt;
}
function hr(e) {
  switch (e.dependenciesState_) {
    case E.UP_TO_DATE_:
      return !1;
    case E.NOT_TRACKING_:
    case E.STALE_:
      return !0;
    case E.POSSIBLY_STALE_: {
      for (var t = Pr(!0), n = Le(), r = e.observing_, i = r.length, o = 0; o < i; o++) {
        var a = r[o];
        if (Ge(a)) {
          if (v.disableErrorBoundaries)
            a.get();
          else
            try {
              a.get();
            } catch {
              return me(n), it(t), !0;
            }
          if (e.dependenciesState_ === E.STALE_)
            return me(n), it(t), !0;
        }
      }
      return Hn(e), me(n), it(t), !1;
    }
  }
}
function zn() {
  return v.trackingDerivation !== null;
}
function le(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.observers_.size > 0;
    !v.allowStateChanges && (t || v.enforceActions === "always") && console.warn("[MobX] " + (v.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + e.name_);
  }
}
function ca(e) {
  process.env.NODE_ENV !== "production" && !v.allowStateReads && v.observableRequiresReaction && console.warn("[mobx] Observable '" + e.name_ + "' being read outside a reactive context.");
}
function Yn(e, t, n) {
  var r = Pr(!0);
  Hn(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++v.runId;
  var i = v.trackingDerivation;
  v.trackingDerivation = e, v.inBatch++;
  var o;
  if (v.disableErrorBoundaries === !0)
    o = t.call(n);
  else
    try {
      o = t.call(n);
    } catch (a) {
      o = new Vt(a);
    }
  return v.inBatch--, v.trackingDerivation = i, fa(e), la(e), it(r), o;
}
function la(e) {
  process.env.NODE_ENV !== "production" && e.observing_.length === 0 && (typeof e.requiresObservable_ == "boolean" ? e.requiresObservable_ : v.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + e.name_ + "' is created/updated without reading any observable value.");
}
function fa(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = E.UP_TO_DATE_, i = 0, o = e.unboundDepsCount_, a = 0; a < o; a++) {
    var u = n[a];
    u.diffValue === 0 && (u.diffValue = 1, i !== a && (n[i] = u), i++), u.dependenciesState_ > r && (r = u.dependenciesState_);
  }
  for (n.length = i, e.newObserving_ = null, o = t.length; o--; ) {
    var c = t[o];
    c.diffValue === 0 && Jn(c, e), c.diffValue = 0;
  }
  for (; i--; ) {
    var f = n[i];
    f.diffValue === 1 && (f.diffValue = 0, va(f, e));
  }
  r !== E.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function _r(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    Jn(t[n], e);
  e.dependenciesState_ = E.NOT_TRACKING_;
}
function Xn(e) {
  var t = Le();
  try {
    return e();
  } finally {
    me(t);
  }
}
function Le() {
  var e = v.trackingDerivation;
  return v.trackingDerivation = null, e;
}
function me(e) {
  v.trackingDerivation = e;
}
function Pr(e) {
  var t = v.allowStateReads;
  return v.allowStateReads = e, t;
}
function it(e) {
  v.allowStateReads = e;
}
function Hn(e) {
  if (e.dependenciesState_ !== E.UP_TO_DATE_) {
    e.dependenciesState_ = E.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = E.UP_TO_DATE_;
  }
}
var ir = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, or = !0, v = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ wr();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (or = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new ir().version && (or = !1), or ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new ir()) : (setTimeout(function() {
    p(35);
  }, 1), new ir());
}();
function da() {
  return v;
}
function va(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function Jn(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && Zn(e);
}
function Zn(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, v.pendingUnobservations.push(e));
}
function H() {
  v.inBatch++;
}
function J() {
  if (--v.inBatch === 0) {
    ni();
    for (var e = v.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof ee && n.suspend_());
    }
    v.pendingUnobservations = [];
  }
}
function Qn(e) {
  ca(e);
  var t = v.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && v.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && v.inBatch > 0 && Zn(e), !1);
}
function ei(e) {
  e.lowestObserverState_ !== E.STALE_ && (e.lowestObserverState_ = E.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === E.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== Q.NONE && ti(t, e), t.onBecomeStale_()), t.dependenciesState_ = E.STALE_;
  }));
}
function pa(e) {
  e.lowestObserverState_ !== E.STALE_ && (e.lowestObserverState_ = E.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === E.POSSIBLY_STALE_ ? (t.dependenciesState_ = E.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== Q.NONE && ti(t, e)) : t.dependenciesState_ === E.UP_TO_DATE_ && (e.lowestObserverState_ = E.UP_TO_DATE_);
  }));
}
function ha(e) {
  e.lowestObserverState_ === E.UP_TO_DATE_ && (e.lowestObserverState_ = E.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === E.UP_TO_DATE_ && (t.dependenciesState_ = E.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function ti(e, t) {
  if (console.log("[mobx.trace] '" + e.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), e.isTracing_ === Q.BREAK) {
    var n = [];
    ri(Va(e), n, 1), new Function(`debugger;
/*
Tracing '` + e.name_ + `'

You are entering this break point because derivation '` + e.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (e instanceof ee ? e.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + n.join(`
`) + `
*/
    `)();
  }
}
function ri(e, t, n) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(n - 1) + e.name), e.dependencies && e.dependencies.forEach(function(r) {
    return ri(r, t, n + 1);
  });
}
var Oe = /* @__PURE__ */ function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Reaction@" + te() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = E.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = Q.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = i, this.requiresObservable_ = o;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, v.pendingReactions.push(this), ni());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      H(), this.isScheduled = !1;
      var r = v.trackingContext;
      if (v.trackingContext = this, hr(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && B() && Ce({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      v.trackingContext = r, J();
    }
  }, t.track = function(r) {
    if (!this.isDisposed) {
      H();
      var i = B(), o;
      process.env.NODE_ENV !== "production" && i && (o = Date.now(), G({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var a = v.trackingContext;
      v.trackingContext = this;
      var u = Yn(this, r, void 0);
      v.trackingContext = a, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && _r(this), Nt(u) && this.reportExceptionInDerivation_(u.cause), process.env.NODE_ENV !== "production" && i && W({
        time: Date.now() - o
      }), J();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (v.disableErrorBoundaries)
      throw r;
    var o = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    v.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(o, r), process.env.NODE_ENV !== "production" && B() && Ce({
      type: "error",
      name: this.name_,
      message: o,
      error: "" + r
    }), v.globalReactionErrorHandlers.forEach(function(a) {
      return a(r, i);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (H(), _r(this), J()));
  }, t.getDisposer_ = function(r) {
    var i = this, o = function a() {
      i.dispose(), r == null || r.removeEventListener == null || r.removeEventListener("abort", a);
    };
    return r == null || r.addEventListener == null || r.addEventListener("abort", o), o[g] = this, o;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
    r === void 0 && (r = !1), Fa(this, r);
  }, ze(e, [{
    key: "isDisposed",
    get: function() {
      return $(this.flags_, e.isDisposedMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isDisposedMask_, r);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return $(this.flags_, e.isScheduledMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isScheduledMask_, r);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return $(this.flags_, e.isTrackPendingMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isTrackPendingMask_, r);
    }
  }, {
    key: "isRunning",
    get: function() {
      return $(this.flags_, e.isRunningMask_);
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.isRunningMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return $(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = K(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
Oe.isDisposedMask_ = 1;
Oe.isScheduledMask_ = 2;
Oe.isTrackPendingMask_ = 4;
Oe.isRunningMask_ = 8;
Oe.diffValueMask_ = 16;
var pn = 100, _a = function(t) {
  return t();
};
function ni() {
  v.inBatch > 0 || v.isRunningReactions || _a(ba);
}
function ba() {
  v.isRunningReactions = !0;
  for (var e = v.pendingReactions, t = 0; e.length > 0; ) {
    ++t === pn && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + pn + " iterations." + (" Probably there is a cycle in the reactive function: " + e[0]) : "[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, i = n.length; r < i; r++)
      n[r].runReaction_();
  }
  v.isRunningReactions = !1;
}
var Rt = /* @__PURE__ */ Ie("Reaction", Oe);
function B() {
  return process.env.NODE_ENV !== "production" && !!v.spyListeners.length;
}
function Ce(e) {
  if (process.env.NODE_ENV !== "production" && v.spyListeners.length)
    for (var t = v.spyListeners, n = 0, r = t.length; n < r; n++)
      t[n](e);
}
function G(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = ye({}, e, {
      spyReportStart: !0
    });
    Ce(t);
  }
}
var ga = {
  type: "report-end",
  spyReportEnd: !0
};
function W(e) {
  process.env.NODE_ENV !== "production" && Ce(e ? ye({}, e, {
    type: "report-end",
    spyReportEnd: !0
  }) : ga);
}
function ma(e) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (v.spyListeners.push(e), Dr(function() {
    v.spyListeners = v.spyListeners.filter(function(t) {
      return t !== e;
    });
  }));
}
var Vr = "action", ya = "action.bound", ii = "autoAction", Oa = "autoAction.bound", oi = "<unnamed action>", br = /* @__PURE__ */ ft(Vr), Ea = /* @__PURE__ */ ft(ya, {
  bound: !0
}), gr = /* @__PURE__ */ ft(ii, {
  autoAction: !0
}), Aa = /* @__PURE__ */ ft(Oa, {
  autoAction: !0,
  bound: !0
});
function ai(e) {
  var t = function(r, i) {
    if (V(r))
      return Te(r.name || oi, r, e);
    if (V(i))
      return Te(r, i, e);
    if (lt(i))
      return (e ? gr : br).decorate_20223_(r, i);
    if (Ne(i))
      return ct(r, i, e ? gr : br);
    if (Ne(r))
      return de(ft(e ? ii : Vr, {
        name: r,
        autoAction: e
      }));
    process.env.NODE_ENV !== "production" && p("Invalid arguments for `action`");
  };
  return t;
}
var C = /* @__PURE__ */ ai(!1);
Object.assign(C, br);
var ot = /* @__PURE__ */ ai(!0);
Object.assign(ot, gr);
C.bound = /* @__PURE__ */ de(Ea);
ot.bound = /* @__PURE__ */ de(Aa);
function si(e) {
  return qn(e.name || oi, !1, e, this, void 0);
}
function Me(e) {
  return V(e) && e.isMobxAction === !0;
}
function wa(e, t) {
  var n, r, i, o;
  t === void 0 && (t = Nr), process.env.NODE_ENV !== "production" && (V(e) || p("Autorun expects a function as first argument"), Me(e) && p("Autorun does not accept actions since actions are untrackable"));
  var a = (n = (r = t) == null ? void 0 : r.name) != null ? n : process.env.NODE_ENV !== "production" ? e.name || "Autorun@" + te() : "Autorun", u = !t.scheduler && !t.delay, c;
  if (u)
    c = new Oe(a, function() {
      this.track(_);
    }, t.onError, t.requiresObservable);
  else {
    var f = ui(t), l = !1;
    c = new Oe(a, function() {
      l || (l = !0, f(function() {
        l = !1, c.isDisposed || c.track(_);
      }));
    }, t.onError, t.requiresObservable);
  }
  function _() {
    e(c);
  }
  return (i = t) != null && (i = i.signal) != null && i.aborted || c.schedule_(), c.getDisposer_((o = t) == null ? void 0 : o.signal);
}
var Na = function(t) {
  return t();
};
function ui(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : Na;
}
function Da(e, t, n) {
  var r, i, o;
  n === void 0 && (n = Nr), process.env.NODE_ENV !== "production" && ((!V(e) || !V(t)) && p("First and second argument to reaction should be functions"), se(n) || p("Third argument of reactions should be an object"));
  var a = (r = n.name) != null ? r : process.env.NODE_ENV !== "production" ? "Reaction@" + te() : "Reaction", u = C(a, n.onError ? Sa(n.onError, t) : t), c = !n.scheduler && !n.delay, f = ui(n), l = !0, _ = !1, b, j = n.compareStructural ? Ke.structural : n.equals || Ke.default, x = new Oe(a, function() {
    l || c ? I() : _ || (_ = !0, f(I));
  }, n.onError, n.requiresObservable);
  function I() {
    if (_ = !1, !x.isDisposed) {
      var M = !1, L = b;
      x.track(function() {
        var D = sa(!1, function() {
          return e(x);
        });
        M = l || !j(b, D), b = D;
      }), (l && n.fireImmediately || !l && M) && u(b, L, x), l = !1;
    }
  }
  return (i = n) != null && (i = i.signal) != null && i.aborted || x.schedule_(), x.getDisposer_((o = n) == null ? void 0 : o.signal);
}
function Sa(e, t) {
  return function() {
    try {
      return t.apply(this, arguments);
    } catch (n) {
      e.call(this, n);
    }
  };
}
var ja = "onBO", Pa = "onBUO";
function ci(e, t, n) {
  return li(ja, e, t, n);
}
function dt(e, t, n) {
  return li(Pa, e, t, n);
}
function li(e, t, n, r) {
  var i = typeof r == "function" ? Ee(t, n) : Ee(t), o = V(r) ? r : n, a = e + "L";
  return i[a] ? i[a].add(o) : i[a] = /* @__PURE__ */ new Set([o]), function() {
    var u = i[a];
    u && (u.delete(o), u.size === 0 && delete i[a]);
  };
}
function fi(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && p("'extendObservable' expected 2-4 arguments"), typeof e != "object" && p("'extendObservable' expects an object as first argument"), pe(e) && p("'extendObservable' should not be used on maps, use map.merge instead"), se(t) || p("'extendObservable' only accepts plain objects as second argument"), (st(t) || st(n)) && p("Extending an object with another observable (object) is not supported"));
  var i = co(t);
  return Be(function() {
    var o = Xe(e, r)[g];
    $t(i).forEach(function(a) {
      o.extend_(
        a,
        i[a],
        // must pass "undefined" for { key: undefined }
        n && a in n ? n[a] : !0
      );
    });
  }), e;
}
function Va(e, t) {
  return di(Ee(e, t));
}
function di(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = Ra(e.observing_).map(di)), t;
}
function Ra(e) {
  return Array.from(new Set(e));
}
var xa = 0;
function vi() {
  this.message = "FLOW_CANCELLED";
}
vi.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var ar = /* @__PURE__ */ kn("flow"), Ta = /* @__PURE__ */ kn("flow.bound", {
  bound: !0
}), We = /* @__PURE__ */ Object.assign(function(t, n) {
  if (lt(n))
    return ar.decorate_20223_(t, n);
  if (Ne(n))
    return ct(t, n, ar);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && p("Flow expects single argument with generator function");
  var r = t, i = r.name || "<unnamed flow>", o = function() {
    var u = this, c = arguments, f = ++xa, l = C(i + " - runid: " + f + " - init", r).apply(u, c), _, b = void 0, j = new Promise(function(x, I) {
      var M = 0;
      _ = I;
      function L(k) {
        b = void 0;
        var ce;
        try {
          ce = C(i + " - runid: " + f + " - yield " + M++, l.next).call(l, k);
        } catch (he) {
          return I(he);
        }
        je(ce);
      }
      function D(k) {
        b = void 0;
        var ce;
        try {
          ce = C(i + " - runid: " + f + " - yield " + M++, l.throw).call(l, k);
        } catch (he) {
          return I(he);
        }
        je(ce);
      }
      function je(k) {
        if (V(k == null ? void 0 : k.then)) {
          k.then(je, I);
          return;
        }
        return k.done ? x(k.value) : (b = Promise.resolve(k.value), b.then(L, D));
      }
      L(void 0);
    });
    return j.cancel = C(i + " - runid: " + f + " - cancel", function() {
      try {
        b && hn(b);
        var x = l.return(void 0), I = Promise.resolve(x.value);
        I.then(Ue, Ue), hn(I), _(new vi());
      } catch (M) {
        _(M);
      }
    }), j;
  };
  return o.isMobXFlow = !0, o;
}, ar);
We.bound = /* @__PURE__ */ de(Ta);
function hn(e) {
  V(e.cancel) && e.cancel();
}
function at(e) {
  return (e == null ? void 0 : e.isMobXFlow) === !0;
}
function pi(e, t) {
  if (t === void 0)
    return Ge(e);
  if (Se(e) === !1 || !e[g].values_.has(t))
    return !1;
  var n = Ee(e, t);
  return Ge(n);
}
function Ca(e) {
  return process.env.NODE_ENV !== "production" && arguments.length > 1 ? p("isComputed expects only 1 argument. Use isComputedProp to inspect the observability of a property") : pi(e);
}
function sr(e, t) {
  return process.env.NODE_ENV !== "production" && !Ne(t) ? p("isComputed expected a property name as second argument") : pi(e, t);
}
function Ma(e, t) {
  return e ? Se(e) || !!e[g] || Sr(e) || Rt(e) || Ge(e) : !1;
}
function st(e) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && p("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), Ma(e);
}
function Ia(e) {
  if (Se(e))
    return e[g].keys_();
  if (pe(e) || ne(e))
    return Array.from(e.keys());
  if (Ye(e))
    return e.map(function(t, n) {
      return n;
    });
  p(5);
}
function La(e, t, n, r) {
  return V(n) ? ka(e, t, n, r) : Ba(e, t, n);
}
function Ba(e, t, n) {
  return He(e).observe_(t, n);
}
function ka(e, t, n, r) {
  return He(e, t).observe_(n, r);
}
function Fa() {
  if (process.env.NODE_ENV !== "production") {
    for (var e = !1, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[n.length - 1] == "boolean" && (e = n.pop());
    var i = Ua(n);
    if (!i)
      return p("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === Q.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = e ? Q.BREAK : Q.LOG;
  }
}
function Ua(e) {
  switch (e.length) {
    case 0:
      return v.trackingDerivation;
    case 1:
      return Ee(e[0]);
    case 2:
      return Ee(e[0], e[1]);
  }
}
function re(e, t) {
  t === void 0 && (t = void 0), H();
  try {
    return e.apply(t);
  } finally {
    J();
  }
}
function Ve(e) {
  return e[g];
}
var $a = {
  has: function(t, n) {
    return process.env.NODE_ENV !== "production" && v.trackingDerivation && tt("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Ve(t).has_(n);
  },
  get: function(t, n) {
    return Ve(t).get_(n);
  },
  set: function(t, n, r) {
    var i;
    return Ne(n) ? (process.env.NODE_ENV !== "production" && !Ve(t).values_.has(n) && tt("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = Ve(t).set_(n, r, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return process.env.NODE_ENV !== "production" && tt("delete properties from an observable object. Use 'remove' from 'mobx' instead."), Ne(n) ? (r = Ve(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var i;
    return process.env.NODE_ENV !== "production" && tt("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = Ve(t).defineProperty_(n, r)) != null ? i : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && v.trackingDerivation && tt("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Ve(t).ownKeys_();
  },
  preventExtensions: function(t) {
    p(13);
  }
};
function Ka(e, t) {
  var n, r;
  return Rn(), e = Xe(e, t), (r = (n = e[g]).proxy_) != null ? r : n.proxy_ = new Proxy(e, $a);
}
function Y(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function vt(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), Dr(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function X(e, t) {
  var n = Le();
  try {
    for (var r = [].concat(e.interceptors_ || []), i = 0, o = r.length; i < o && (t = r[i](t), t && !t.type && p(14), !!t); i++)
      ;
    return t;
  } finally {
    me(n);
  }
}
function oe(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function pt(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), Dr(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function ae(e, t) {
  var n = Le(), r = e.changeListeners_;
  if (r) {
    r = r.slice();
    for (var i = 0, o = r.length; i < o; i++)
      r[i](t);
    me(n);
  }
}
function Yt(e, t, n) {
  return Be(function() {
    var r, i = Xe(e, n)[g];
    process.env.NODE_ENV !== "production" && t && e[U] && p("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (r = t) != null || (t = _o(e)), $t(t).forEach(function(o) {
      return i.make_(o, t[o]);
    });
  }), e;
}
var _n = "splice", ie = "update", Ga = 1e4, Wa = {
  get: function(t, n) {
    var r = t[g];
    return n === g ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : Z(xt, n) ? xt[n] : t[n];
  },
  set: function(t, n, r) {
    var i = t[g];
    return n === "length" && i.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : i.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    p(15);
  }
}, Rr = /* @__PURE__ */ function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + te() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = o, this.atom_ = new De(n), this.enhancer_ = function(a, u) {
      return r(a, u, process.env.NODE_ENV !== "production" ? n + "[..]" : "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return vt(this, r);
  }, t.observe_ = function(r, i) {
    return i === void 0 && (i = !1), i && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), pt(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && p("Out of range: " + r);
    var i = this.values_.length;
    if (r !== i)
      if (r > i) {
        for (var o = new Array(r - i), a = 0; a < r - i; a++)
          o[a] = void 0;
        this.spliceWithArray_(i, 0, o);
      } else
        this.spliceWithArray_(r, i - r);
  }, t.updateArrayLength_ = function(r, i) {
    r !== this.lastKnownLength_ && p(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && mi(r + i + 1);
  }, t.spliceWithArray_ = function(r, i, o) {
    var a = this;
    le(this.atom_);
    var u = this.values_.length;
    if (r === void 0 ? r = 0 : r > u ? r = u : r < 0 && (r = Math.max(0, u + r)), arguments.length === 1 ? i = u - r : i == null ? i = 0 : i = Math.max(0, Math.min(i, u - r)), o === void 0 && (o = St), Y(this)) {
      var c = X(this, {
        object: this.proxy_,
        type: _n,
        index: r,
        removedCount: i,
        added: o
      });
      if (!c)
        return St;
      i = c.removedCount, o = c.added;
    }
    if (o = o.length === 0 ? o : o.map(function(_) {
      return a.enhancer_(_, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var f = o.length - i;
      this.updateArrayLength_(u, f);
    }
    var l = this.spliceItemsIntoValues_(r, i, o);
    return (i !== 0 || o.length !== 0) && this.notifyArraySplice_(r, o, l), this.dehanceValues_(l);
  }, t.spliceItemsIntoValues_ = function(r, i, o) {
    if (o.length < Ga) {
      var a;
      return (a = this.values_).splice.apply(a, [r, i].concat(o));
    } else {
      var u = this.values_.slice(r, r + i), c = this.values_.slice(r + i);
      this.values_.length += o.length - i;
      for (var f = 0; f < o.length; f++)
        this.values_[r + f] = o[f];
      for (var l = 0; l < c.length; l++)
        this.values_[r + o.length + l] = c[l];
      return u;
    }
  }, t.notifyArrayChildUpdate_ = function(r, i, o) {
    var a = !this.owned_ && B(), u = oe(this), c = u || a ? {
      observableKind: "array",
      object: this.proxy_,
      type: ie,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: i,
      oldValue: o
    } : null;
    process.env.NODE_ENV !== "production" && a && G(c), this.atom_.reportChanged(), u && ae(this, c), process.env.NODE_ENV !== "production" && a && W();
  }, t.notifyArraySplice_ = function(r, i, o) {
    var a = !this.owned_ && B(), u = oe(this), c = u || a ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: _n,
      index: r,
      removed: o,
      added: i,
      removedCount: o.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && a && G(c), this.atom_.reportChanged(), u && ae(this, c), process.env.NODE_ENV !== "production" && a && W();
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + r + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, i) {
    var o = this.values_;
    if (this.legacyMode_ && r > o.length && p(17, r, o.length), r < o.length) {
      le(this.atom_);
      var a = o[r];
      if (Y(this)) {
        var u = X(this, {
          type: ie,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: r,
          newValue: i
        });
        if (!u)
          return;
        i = u.newValue;
      }
      i = this.enhancer_(i, a);
      var c = i !== a;
      c && (o[r] = i, this.notifyArrayChildUpdate_(r, i, a));
    } else {
      for (var f = new Array(r + 1 - o.length), l = 0; l < f.length - 1; l++)
        f[l] = void 0;
      f[f.length - 1] = i, this.spliceWithArray_(o.length, 0, f);
    }
  }, e;
}();
function qa(e, t, n, r) {
  return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + te() : "ObservableArray"), r === void 0 && (r = !1), Rn(), Be(function() {
    var i = new Rr(n, t, r, !1);
    Tn(i.values_, g, i);
    var o = new Proxy(i.values_, Wa);
    return i.proxy_ = o, e && e.length && i.spliceWithArray_(0, 0, e), o;
  });
}
var xt = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[g];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, n) {
    for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
      i[o - 2] = arguments[o];
    var a = this[g];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return a.spliceWithArray_(t);
      case 2:
        return a.spliceWithArray_(t, n);
    }
    return a.spliceWithArray_(t, n, i);
  },
  spliceWithArray: function(t, n, r) {
    return this[g].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[g], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[g].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[g], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return v.trackingDerivation && p(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    v.trackingDerivation && p(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[g], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
N("at", q);
N("concat", q);
N("flat", q);
N("includes", q);
N("indexOf", q);
N("join", q);
N("lastIndexOf", q);
N("slice", q);
N("toString", q);
N("toLocaleString", q);
N("toSorted", q);
N("toSpliced", q);
N("with", q);
N("every", ue);
N("filter", ue);
N("find", ue);
N("findIndex", ue);
N("findLast", ue);
N("findLastIndex", ue);
N("flatMap", ue);
N("forEach", ue);
N("map", ue);
N("some", ue);
N("toReversed", ue);
N("reduce", hi);
N("reduceRight", hi);
function N(e, t) {
  typeof Array.prototype[e] == "function" && (xt[e] = t(e));
}
function q(e) {
  return function() {
    var t = this[g];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function ue(e) {
  return function(t, n) {
    var r = this, i = this[g];
    i.atom_.reportObserved();
    var o = i.dehanceValues_(i.values_);
    return o[e](function(a, u) {
      return t.call(n, a, u, r);
    });
  };
}
function hi(e) {
  return function() {
    var t = this, n = this[g];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), i = arguments[0];
    return arguments[0] = function(o, a, u) {
      return i(o, a, u, t);
    }, r[e].apply(r, arguments);
  };
}
var za = /* @__PURE__ */ Ie("ObservableArrayAdministration", Rr);
function Ye(e) {
  return Ft(e) && za(e[g]);
}
var Ya = {}, we = "add", Tt = "delete", xr = /* @__PURE__ */ function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = xe), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + te() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[g] = Ya, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = i, V(Map) || p(18), Be(function() {
      o.keysAtom_ = Ln(process.env.NODE_ENV !== "production" ? o.name_ + ".keys()" : "ObservableMap.keys()"), o.data_ = /* @__PURE__ */ new Map(), o.hasMap_ = /* @__PURE__ */ new Map(), n && o.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var i = this;
    if (!v.trackingDerivation)
      return this.has_(r);
    var o = this.hasMap_.get(r);
    if (!o) {
      var a = o = new Re(this.has_(r), Gt, process.env.NODE_ENV !== "production" ? this.name_ + "." + fr(r) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(r, a), dt(a, function() {
        return i.hasMap_.delete(r);
      });
    }
    return o.get();
  }, t.set = function(r, i) {
    var o = this.has_(r);
    if (Y(this)) {
      var a = X(this, {
        type: o ? ie : we,
        object: this,
        newValue: i,
        name: r
      });
      if (!a)
        return this;
      i = a.newValue;
    }
    return o ? this.updateValue_(r, i) : this.addValue_(r, i), this;
  }, t.delete = function(r) {
    var i = this;
    if (le(this.keysAtom_), Y(this)) {
      var o = X(this, {
        type: Tt,
        object: this,
        name: r
      });
      if (!o)
        return !1;
    }
    if (this.has_(r)) {
      var a = B(), u = oe(this), c = u || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Tt,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return process.env.NODE_ENV !== "production" && a && G(c), re(function() {
        var f;
        i.keysAtom_.reportChanged(), (f = i.hasMap_.get(r)) == null || f.setNewValue_(!1);
        var l = i.data_.get(r);
        l.setNewValue_(void 0), i.data_.delete(r);
      }), u && ae(this, c), process.env.NODE_ENV !== "production" && a && W(), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, i) {
    var o = this.data_.get(r);
    if (i = o.prepareNewValue_(i), i !== v.UNCHANGED) {
      var a = B(), u = oe(this), c = u || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: ie,
        object: this,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && a && G(c), o.setNewValue_(i), u && ae(this, c), process.env.NODE_ENV !== "production" && a && W();
    }
  }, t.addValue_ = function(r, i) {
    var o = this;
    le(this.keysAtom_), re(function() {
      var f, l = new Re(i, o.enhancer_, process.env.NODE_ENV !== "production" ? o.name_ + "." + fr(r) : "ObservableMap.key", !1);
      o.data_.set(r, l), i = l.value_, (f = o.hasMap_.get(r)) == null || f.setNewValue_(!0), o.keysAtom_.reportChanged();
    });
    var a = B(), u = oe(this), c = u || a ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: we,
      object: this,
      name: r,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && a && G(c), u && ae(this, c), process.env.NODE_ENV !== "production" && a && W();
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, i = this.keys();
    return bn({
      next: function() {
        var a = i.next(), u = a.done, c = a.value;
        return {
          done: u,
          value: u ? void 0 : r.get(c)
        };
      }
    });
  }, t.entries = function() {
    var r = this, i = this.keys();
    return bn({
      next: function() {
        var a = i.next(), u = a.done, c = a.value;
        return {
          done: u,
          value: u ? void 0 : [c, r.get(c)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(r, i) {
    for (var o = $e(this), a; !(a = o()).done; ) {
      var u = a.value, c = u[0], f = u[1];
      r.call(i, f, c, this);
    }
  }, t.merge = function(r) {
    var i = this;
    return pe(r) && (r = new Map(r)), re(function() {
      se(r) ? uo(r).forEach(function(o) {
        return i.set(o, r[o]);
      }) : Array.isArray(r) ? r.forEach(function(o) {
        var a = o[0], u = o[1];
        return i.set(a, u);
      }) : qe(r) ? (so(r) || p(19, r), r.forEach(function(o, a) {
        return i.set(a, o);
      })) : r != null && p(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    re(function() {
      Xn(function() {
        for (var i = $e(r.keys()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.replace = function(r) {
    var i = this;
    return re(function() {
      for (var o = Xa(r), a = /* @__PURE__ */ new Map(), u = !1, c = $e(i.data_.keys()), f; !(f = c()).done; ) {
        var l = f.value;
        if (!o.has(l)) {
          var _ = i.delete(l);
          if (_)
            u = !0;
          else {
            var b = i.data_.get(l);
            a.set(l, b);
          }
        }
      }
      for (var j = $e(o.entries()), x; !(x = j()).done; ) {
        var I = x.value, M = I[0], L = I[1], D = i.data_.has(M);
        if (i.set(M, L), i.data_.has(M)) {
          var je = i.data_.get(M);
          a.set(M, je), D || (u = !0);
        }
      }
      if (!u)
        if (i.data_.size !== a.size)
          i.keysAtom_.reportChanged();
        else
          for (var k = i.data_.keys(), ce = a.keys(), he = k.next(), ht = ce.next(); !he.done; ) {
            if (he.value !== ht.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            he = k.next(), ht = ce.next();
          }
      i.data_ = a;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && p("`observe` doesn't support fireImmediately=true in combination with maps."), pt(this, r);
  }, t.intercept_ = function(r) {
    return vt(this, r);
  }, ze(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
}(), pe = /* @__PURE__ */ Ie("ObservableMap", xr);
function bn(e) {
  return e[Symbol.toStringTag] = "MapIterator", Mr(e);
}
function Xa(e) {
  if (qe(e) || pe(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (se(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return p(21, e);
}
var Ha = {}, _i = /* @__PURE__ */ function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = xe), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + te() : "ObservableSet"), this.name_ = void 0, this[g] = Ha, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, V(Set) || p(22), this.enhancer_ = function(a, u) {
      return r(a, u, i);
    }, Be(function() {
      o.atom_ = Ln(o.name_), n && o.replace(n);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    re(function() {
      Xn(function() {
        for (var i = $e(r.data_.values()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.forEach = function(r, i) {
    for (var o = $e(this), a; !(a = o()).done; ) {
      var u = a.value;
      r.call(i, u, u, this);
    }
  }, t.add = function(r) {
    var i = this;
    if (le(this.atom_), Y(this)) {
      var o = X(this, {
        type: we,
        object: this,
        newValue: r
      });
      if (!o)
        return this;
    }
    if (!this.has(r)) {
      re(function() {
        i.data_.add(i.enhancer_(r, void 0)), i.atom_.reportChanged();
      });
      var a = process.env.NODE_ENV !== "production" && B(), u = oe(this), c = u || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: we,
        object: this,
        newValue: r
      } : null;
      a && process.env.NODE_ENV !== "production" && G(c), u && ae(this, c), a && process.env.NODE_ENV !== "production" && W();
    }
    return this;
  }, t.delete = function(r) {
    var i = this;
    if (Y(this)) {
      var o = X(this, {
        type: Tt,
        object: this,
        oldValue: r
      });
      if (!o)
        return !1;
    }
    if (this.has(r)) {
      var a = process.env.NODE_ENV !== "production" && B(), u = oe(this), c = u || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Tt,
        object: this,
        oldValue: r
      } : null;
      return a && process.env.NODE_ENV !== "production" && G(c), re(function() {
        i.atom_.reportChanged(), i.data_.delete(r);
      }), u && ae(this, c), a && process.env.NODE_ENV !== "production" && W(), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = 0, i = Array.from(this.keys()), o = Array.from(this.values());
    return gn({
      next: function() {
        var u = r;
        return r += 1, u < o.length ? {
          value: [i[u], o[u]],
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, i = 0, o = Array.from(this.data_.values());
    return gn({
      next: function() {
        return i < o.length ? {
          value: r.dehanceValue_(o[i++]),
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.intersection = function(r) {
    if (ge(r) && !ne(r))
      return r.intersection(this);
    var i = new Set(this);
    return i.intersection(r);
  }, t.union = function(r) {
    if (ge(r) && !ne(r))
      return r.union(this);
    var i = new Set(this);
    return i.union(r);
  }, t.difference = function(r) {
    return new Set(this).difference(r);
  }, t.symmetricDifference = function(r) {
    if (ge(r) && !ne(r))
      return r.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(r);
  }, t.isSubsetOf = function(r) {
    return new Set(this).isSubsetOf(r);
  }, t.isSupersetOf = function(r) {
    return new Set(this).isSupersetOf(r);
  }, t.isDisjointFrom = function(r) {
    if (ge(r) && !ne(r))
      return r.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(r);
  }, t.replace = function(r) {
    var i = this;
    return ne(r) && (r = new Set(r)), re(function() {
      Array.isArray(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : ge(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : r != null && p("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && p("`observe` doesn't support fireImmediately=true in combination with sets."), pt(this, r);
  }, t.intercept_ = function(r) {
    return vt(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, ze(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
}(), ne = /* @__PURE__ */ Ie("ObservableSet", _i);
function gn(e) {
  return e[Symbol.toStringTag] = "SetIterator", Mr(e);
}
var mn = /* @__PURE__ */ Object.create(null), yn = "remove", mr = /* @__PURE__ */ function() {
  function e(n, r, i, o) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), o === void 0 && (o = Uo), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = i, this.defaultAnnotation_ = o, this.keysAtom_ = new De(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = se(this.target_), process.env.NODE_ENV !== "production" && !yi(this.defaultAnnotation_) && p("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    return this.values_.get(r).get();
  }, t.setObservablePropValue_ = function(r, i) {
    var o = this.values_.get(r);
    if (o instanceof ee)
      return o.set(i), !0;
    if (Y(this)) {
      var a = X(this, {
        type: ie,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      });
      if (!a)
        return null;
      i = a.newValue;
    }
    if (i = o.prepareNewValue_(i), i !== v.UNCHANGED) {
      var u = oe(this), c = process.env.NODE_ENV !== "production" && B(), f = u || c ? {
        type: ie,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && c && G(f), o.setNewValue_(i), u && ae(this, f), process.env.NODE_ENV !== "production" && c && W();
    }
    return !0;
  }, t.get_ = function(r) {
    return v.trackingDerivation && !Z(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, i, o) {
    return o === void 0 && (o = !1), Z(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, i) : o ? Reflect.set(this.target_, r, i) : (this.target_[r] = i, !0) : this.extend_(r, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, o);
  }, t.has_ = function(r) {
    if (!v.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(r);
    return i || (i = new Re(r in this.target_, Gt, process.env.NODE_ENV !== "production" ? this.name_ + "." + fr(r) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(r, i)), i.get();
  }, t.make_ = function(r, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (An(this, i, r), !(r in this.target_)) {
        var o;
        if ((o = this.target_[U]) != null && o[r])
          return;
        p(1, i.annotationType_, this.name_ + "." + r.toString());
      }
      for (var a = this.target_; a && a !== kt; ) {
        var u = Dt(a, r);
        if (u) {
          var c = i.make_(this, r, u, a);
          if (c === 0)
            return;
          if (c === 1)
            break;
        }
        a = Object.getPrototypeOf(a);
      }
      En(this, i, r);
    }
  }, t.extend_ = function(r, i, o, a) {
    if (a === void 0 && (a = !1), o === !0 && (o = this.defaultAnnotation_), o === !1)
      return this.defineProperty_(r, i, a);
    An(this, o, r);
    var u = o.extend_(this, r, i, a);
    return u && En(this, o, r), u;
  }, t.defineProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), le(this.keysAtom_);
    try {
      H();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (Y(this)) {
        var u = X(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: we,
          newValue: i.value
        });
        if (!u)
          return null;
        var c = u.newValue;
        i.value !== c && (i = ye({}, i, {
          value: c
        }));
      }
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, i))
          return !1;
      } else
        fe(this.target_, r, i);
      this.notifyPropertyAddition_(r, i.value);
    } finally {
      J();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, i, o, a) {
    a === void 0 && (a = !1), le(this.keysAtom_);
    try {
      H();
      var u = this.delete_(r);
      if (!u)
        return u;
      if (Y(this)) {
        var c = X(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: we,
          newValue: i
        });
        if (!c)
          return null;
        i = c.newValue;
      }
      var f = On(r), l = {
        configurable: v.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: f.get,
        set: f.set
      };
      if (a) {
        if (!Reflect.defineProperty(this.target_, r, l))
          return !1;
      } else
        fe(this.target_, r, l);
      var _ = new Re(i, o, process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key", !1);
      this.values_.set(r, _), this.notifyPropertyAddition_(r, _.value_);
    } finally {
      J();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), le(this.keysAtom_);
    try {
      H();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (Y(this)) {
        var u = X(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: we,
          newValue: void 0
        });
        if (!u)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var c = On(r), f = {
        configurable: v.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: c.get,
        set: c.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, f))
          return !1;
      } else
        fe(this.target_, r, f);
      this.values_.set(r, new ee(i)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      J();
    }
    return !0;
  }, t.delete_ = function(r, i) {
    if (i === void 0 && (i = !1), le(this.keysAtom_), !Z(this.target_, r))
      return !0;
    if (Y(this)) {
      var o = X(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: yn
      });
      if (!o)
        return null;
    }
    try {
      var a;
      H();
      var u = oe(this), c = process.env.NODE_ENV !== "production" && B(), f = this.values_.get(r), l = void 0;
      if (!f && (u || c)) {
        var _;
        l = (_ = Dt(this.target_, r)) == null ? void 0 : _.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[r], f && (this.values_.delete(r), f instanceof Re && (l = f.value_), ei(f)), this.keysAtom_.reportChanged(), (a = this.pendingKeys_) == null || (a = a.get(r)) == null || a.set(r in this.target_), u || c) {
        var b = {
          type: yn,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: l,
          name: r
        };
        process.env.NODE_ENV !== "production" && c && G(b), u && ae(this, b), process.env.NODE_ENV !== "production" && c && W();
      }
    } finally {
      J();
    }
    return !0;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && p("`observe` doesn't support the fire immediately property for observable objects."), pt(this, r);
  }, t.intercept_ = function(r) {
    return vt(this, r);
  }, t.notifyPropertyAddition_ = function(r, i) {
    var o, a = oe(this), u = process.env.NODE_ENV !== "production" && B();
    if (a || u) {
      var c = a || u ? {
        type: we,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && u && G(c), a && ae(this, c), process.env.NODE_ENV !== "production" && u && W();
    }
    (o = this.pendingKeys_) == null || (o = o.get(r)) == null || o.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), $t(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
}();
function Xe(e, t) {
  var n;
  if (process.env.NODE_ENV !== "production" && t && Se(e) && p("Options can't be provided for already observable objects."), Z(e, g))
    return process.env.NODE_ENV !== "production" && !(He(e) instanceof mr) && p("Cannot convert '" + Ct(e) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), e;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(e) && p("Cannot make the designated object observable; it is not extensible");
  var r = (n = t == null ? void 0 : t.name) != null ? n : process.env.NODE_ENV !== "production" ? (se(e) ? "ObservableObject" : e.constructor.name) + "@" + te() : "ObservableObject", i = new mr(e, /* @__PURE__ */ new Map(), String(r), Zo(t));
  return Ut(e, g, i), e;
}
var Ja = /* @__PURE__ */ Ie("ObservableObjectAdministration", mr);
function On(e) {
  return mn[e] || (mn[e] = {
    get: function() {
      return this[g].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[g].setObservablePropValue_(e, n);
    }
  });
}
function Se(e) {
  return Ft(e) ? Ja(e[g]) : !1;
}
function En(e, t, n) {
  var r;
  process.env.NODE_ENV !== "production" && (e.appliedAnnotations_[n] = t), (r = e.target_[U]) == null || delete r[n];
}
function An(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !yi(t) && p("Cannot annotate '" + e.name_ + "." + n.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !jt(t) && Z(e.appliedAnnotations_, n)) {
    var r = e.name_ + "." + n.toString(), i = e.appliedAnnotations_[n].annotationType_, o = t.annotationType_;
    p("Cannot apply '" + o + "' to '" + r + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var Za = /* @__PURE__ */ gi(0), Qa = /* @__PURE__ */ function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
}(), ur = 0, bi = function() {
};
function es(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
es(bi, Array.prototype);
var Tr = /* @__PURE__ */ function(e) {
  function t(r, i, o, a) {
    var u;
    return o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableArray@" + te() : "ObservableArray"), a === void 0 && (a = !1), u = e.call(this) || this, Be(function() {
      var c = new Rr(o, i, a, !0);
      c.proxy_ = u, Tn(u, g, c), r && r.length && u.spliceWithArray(0, 0, r), Qa && Object.defineProperty(u, "0", Za);
    }), u;
  }
  In(t, e);
  var n = t.prototype;
  return n.concat = function() {
    this[g].atom_.reportObserved();
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      o.map(function(u) {
        return Ye(u) ? u.slice() : u;
      })
    );
  }, n[Symbol.iterator] = function() {
    var r = this, i = 0;
    return Mr({
      next: function() {
        return i < r.length ? {
          value: r[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, ze(t, [{
    key: "length",
    get: function() {
      return this[g].getArrayLength_();
    },
    set: function(i) {
      this[g].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
}(bi);
Object.entries(xt).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && Ut(Tr.prototype, t, n);
});
function gi(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[g].get_(e);
    },
    set: function(n) {
      this[g].set_(e, n);
    }
  };
}
function ts(e) {
  fe(Tr.prototype, "" + e, gi(e));
}
function mi(e) {
  if (e > ur) {
    for (var t = ur; t < e + 100; t++)
      ts(t);
    ur = e;
  }
}
mi(1e3);
function rs(e, t, n) {
  return new Tr(e, t, n);
}
function Ee(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Ye(e))
      return t !== void 0 && p(23), e[g].atom_;
    if (ne(e))
      return e.atom_;
    if (pe(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || p(25, t, Ct(e)), n;
    }
    if (Se(e)) {
      if (!t)
        return p(26);
      var r = e[g].values_.get(t);
      return r || p(27, t, Ct(e)), r;
    }
    if (Sr(e) || Ge(e) || Rt(e))
      return e;
  } else if (V(e) && Rt(e[g]))
    return e[g];
  p(28);
}
function He(e, t) {
  if (e || p(29), t !== void 0)
    return He(Ee(e, t));
  if (Sr(e) || Ge(e) || Rt(e) || pe(e) || ne(e))
    return e;
  if (e[g])
    return e[g];
  p(24, e);
}
function Ct(e, t) {
  var n;
  if (t !== void 0)
    n = Ee(e, t);
  else {
    if (Me(e))
      return e.name;
    Se(e) || pe(e) || ne(e) ? n = He(e) : n = Ee(e);
  }
  return n.name_;
}
function Be(e) {
  var t = Le(), n = qt(!0);
  H();
  try {
    return e();
  } finally {
    J(), zt(n), me(t);
  }
}
var wn = kt.toString;
function Cr(e, t, n) {
  return n === void 0 && (n = -1), yr(e, t, n);
}
function yr(e, t, n, r, i) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var o = typeof e;
  if (o !== "function" && o !== "object" && typeof t != "object")
    return !1;
  var a = wn.call(e);
  if (a !== wn.call(t))
    return !1;
  switch (a) {
    case "[object RegExp]":
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = Nn(e), t = Nn(t);
  var u = a === "[object Array]";
  if (!u) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var c = e.constructor, f = t.constructor;
    if (c !== f && !(V(c) && c instanceof c && V(f) && f instanceof f) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], i = i || [];
  for (var l = r.length; l--; )
    if (r[l] === e)
      return i[l] === t;
  if (r.push(e), i.push(t), u) {
    if (l = e.length, l !== t.length)
      return !1;
    for (; l--; )
      if (!yr(e[l], t[l], n - 1, r, i))
        return !1;
  } else {
    var _ = Object.keys(e), b;
    if (l = _.length, Object.keys(t).length !== l)
      return !1;
    for (; l--; )
      if (b = _[l], !(Z(t, b) && yr(e[b], t[b], n - 1, r, i)))
        return !1;
  }
  return r.pop(), i.pop(), !0;
}
function Nn(e) {
  return Ye(e) ? e.slice() : qe(e) || pe(e) || ge(e) || ne(e) ? Array.from(e.entries()) : e;
}
var Dn, ns = ((Dn = wr().Iterator) == null ? void 0 : Dn.prototype) || {};
function Mr(e) {
  return e[Symbol.iterator] = is, Object.assign(Object.create(ns), e);
}
function is() {
  return this;
}
function yi(e) {
  return (
    // Can be function
    e instanceof Object && typeof e.annotationType_ == "string" && V(e.make_) && V(e.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = wr();
  typeof t[e] > "u" && p("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: ma,
  extras: {
    getDebugName: Ct
  },
  $mobx: g
});
function os(e) {
  throw new Error("[mobx-utils] " + e);
}
function ut(e, t) {
  t === void 0 && (t = "Illegal state"), e || os(t);
}
var Oi = function(e) {
  return e && e !== Object.prototype && Object.getOwnPropertyNames(e).concat(Oi(Object.getPrototypeOf(e)) || []);
}, as = function(e) {
  var t = Oi(e), n = t.filter(function(r, i) {
    return t.indexOf(r) === i;
  });
  return n;
}, Sn = function(e) {
  return as(e).filter(function(t) {
    return t !== "constructor" && !~t.indexOf("__");
  });
}, Or = "pending", Mt = "fulfilled", Ir = "rejected";
function ss(e) {
  switch (this.state) {
    case Or:
      return e.pending && e.pending(this.value);
    case Ir:
      return e.rejected && e.rejected(this.value);
    case Mt:
      return e.fulfilled ? e.fulfilled(this.value) : this.value;
  }
}
function jn(e, t) {
  if (ut(arguments.length <= 2, "fromPromise expects up to two arguments"), ut(typeof e == "function" || typeof e == "object" && e && typeof e.then == "function", "Please pass a promise or function to fromPromise"), e.isPromiseBasedObservable === !0)
    return e;
  typeof e == "function" && (e = new Promise(e));
  var n = e;
  e.then(C("observableFromPromise-resolve", function(i) {
    n.value = i, n.state = Mt;
  }), C("observableFromPromise-reject", function(i) {
    n.value = i, n.state = Ir;
  })), n.isPromiseBasedObservable = !0, n.case = ss;
  var r = t && (t.state === Mt || t.state === Or) ? t.value : void 0;
  return fi(n, {
    value: r,
    state: Or
  }, {}, { deep: !1 }), n;
}
(function(e) {
  e.reject = C("fromPromise.reject", function(n) {
    var r = e(Promise.reject(n));
    return r.state = Ir, r.value = n, r;
  });
  function t(n) {
    n === void 0 && (n = void 0);
    var r = e(Promise.resolve(n));
    return r.state = Mt, r.value = n, r;
  }
  e.resolve = C("fromPromise.resolve", t);
})(jn || (jn = {}));
var At = function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, n, r);
  else for (var u = e.length - 1; u >= 0; u--) (a = e[u]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
};
(function() {
  function e(t, n) {
    var r = this;
    Object.defineProperty(this, "current", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "subscription", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Yt(this), si(function() {
      r.current = n, r.subscription = t.subscribe(r);
    });
  }
  return Object.defineProperty(e.prototype, "dispose", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      this.subscription && this.subscription.unsubscribe();
    }
  }), Object.defineProperty(e.prototype, "next", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      this.current = t;
    }
  }), Object.defineProperty(e.prototype, "complete", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      this.dispose();
    }
  }), Object.defineProperty(e.prototype, "error", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      this.current = t, this.dispose();
    }
  }), At([
    P.ref
  ], e.prototype, "current", void 0), At([
    C.bound
  ], e.prototype, "next", null), At([
    C.bound
  ], e.prototype, "complete", null), At([
    C.bound
  ], e.prototype, "error", null), e;
})();
var It = function() {
  return It = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, It.apply(this, arguments);
}, rt = function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, n, r);
  else for (var u = e.length - 1; u >= 0; u--) (a = e[u]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, us = ["model", "reset", "submit", "isDirty", "isPropertyDirty", "resetProperty"];
(function() {
  function e(t) {
    var n = this;
    Object.defineProperty(this, "model", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }), Object.defineProperty(this, "localValues", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: P.map({})
    }), Object.defineProperty(this, "localComputedValues", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: P.map({})
    }), Object.defineProperty(this, "isPropertyDirty", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: function(i) {
        return n.localValues.has(i);
      }
    }), Yt(this), ut(Se(t), "createViewModel expects an observable object");
    var r = Sn(this);
    Sn(t).forEach(function(i) {
      var o;
      if (!r.includes(i) && !(i === g || i === "__mobxDidRunLazyInitializers")) {
        if (ut(us.indexOf(i) === -1, "The propertyname " + i + " is reserved and cannot be used with viewModels"), sr(t, i)) {
          var a = He(t, i), u = a.derivation.bind(n), c = (o = a.setter_) === null || o === void 0 ? void 0 : o.bind(n);
          n.localComputedValues.set(i, ve(u, { set: c }));
        }
        var f = Object.getOwnPropertyDescriptor(t, i), l = f ? { enumerable: f.enumerable } : {};
        Object.defineProperty(n, i, It(It({}, l), { configurable: !0, get: function() {
          return sr(t, i) ? n.localComputedValues.get(i).get() : n.isPropertyDirty(i) ? n.localValues.get(i) : n.model[i];
        }, set: C(function(_) {
          sr(t, i) ? n.localComputedValues.get(i).set(_) : _ !== n.model[i] ? n.localValues.set(i, _) : n.localValues.delete(i);
        }) }));
      }
    });
  }
  return Object.defineProperty(e.prototype, "isDirty", {
    get: function() {
      return this.localValues.size > 0;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "changedValues", {
    get: function() {
      return new Map(this.localValues);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "submit", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      var t = this;
      Ia(this.localValues).forEach(function(n) {
        var r = t.localValues.get(n), i = t.model[n];
        Ye(i) ? i.replace(r) : pe(i) ? (i.clear(), i.merge(r)) : Ca(r) || (t.model[n] = r);
      }), this.localValues.clear();
    }
  }), Object.defineProperty(e.prototype, "reset", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      this.localValues.clear();
    }
  }), Object.defineProperty(e.prototype, "resetProperty", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      this.localValues.delete(t);
    }
  }), rt([
    ve
  ], e.prototype, "isDirty", null), rt([
    ve
  ], e.prototype, "changedValues", null), rt([
    C.bound
  ], e.prototype, "submit", null), rt([
    C.bound
  ], e.prototype, "reset", null), rt([
    C.bound
  ], e.prototype, "resetProperty", null), e;
})();
var Lt = function() {
  return Lt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Lt.apply(this, arguments);
};
function cs(e, t) {
  ut(typeof e == "function" && e.length < 2, "createTransformer expects a function that accepts one argument");
  var n = /* @__PURE__ */ new Map(), r = void 0, i = void 0;
  function o(u) {
    var c, f = {};
    r = void 0, i = void 0;
    var l = typeof u, _ = i ? i(u) : "Transformer-" + e.name + "-" + (l === "string" || l === "number" ? u : "object"), b = ve(function() {
      return c = e(u);
    }, Lt(Lt({}, f), { name: _ })), j = dt(b, function() {
      n.delete(u), j(), r && r(c, u);
    });
    return b;
  }
  var a = !1;
  return function(u) {
    ls(u);
    var c = n.get(u);
    if (c)
      return c.get();
    if (!zn()) {
      a || (console.warn("invoking a transformer from outside a reactive context won't memorized and is cleaned up immediately, unless keepAlive is set"), a = !0);
      var f = e(u);
      return r && r(f, u), f;
    }
    return c = o(u), n.set(u, c), c.get();
  };
}
function ls(e) {
  var t = typeof e;
  if (e === null || t !== "object" && t !== "function" && t !== "string" && t !== "number")
    throw new Error("[mobx-utils] transform expected an object, function, string or number, got: " + String(e));
}
var fs = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
(function(e) {
  fs(t, e);
  function t(n, r, i) {
    var o = i === void 0 ? {} : i, a = o.name, u = a === void 0 ? "ogm" + (Math.random() * 1e3 | 0) : a, c = o.keyToName, f = c === void 0 ? function(b) {
      return "" + b;
    } : c, l = e.call(this) || this;
    Object.defineProperty(l, "_base", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(l, "_ogmInfoKey", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(l, "_groupBy", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(l, "_keyToName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(l, "_disposeBaseObserver", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), l._keyToName = f, l._groupBy = r, l._ogmInfoKey = Symbol("ogmInfo" + u), l._base = n;
    for (var _ = 0; _ < n.length; _++)
      l._addItem(n[_]);
    return l._disposeBaseObserver = La(l._base, function(b) {
      if (b.type === "splice")
        re(function() {
          for (var j = 0, x = b.removed; j < x.length; j++) {
            var I = x[j];
            l._removeItem(I);
          }
          for (var M = 0, L = b.added; M < L.length; M++) {
            var D = L[M];
            l._addItem(D);
          }
        });
      else if (b.type === "update")
        re(function() {
          l._removeItem(b.oldValue), l._addItem(b.newValue);
        });
      else
        throw new Error("illegal state");
    }), l;
  }
  return Object.defineProperty(t.prototype, "clear", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      throw new Error("not supported");
    }
  }), Object.defineProperty(t.prototype, "delete", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(n) {
      throw new Error("not supported");
    }
  }), Object.defineProperty(t.prototype, "set", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(n, r) {
      throw new Error("not supported");
    }
  }), Object.defineProperty(t.prototype, "dispose", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      this._disposeBaseObserver();
      for (var n = 0; n < this._base.length; n++) {
        var r = this._base[n], i = r[this._ogmInfoKey];
        i.reaction(), delete r[this._ogmInfoKey];
      }
    }
  }), Object.defineProperty(t.prototype, "_getGroupArr", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(n) {
      var r = e.prototype.get.call(this, n);
      return r === void 0 && (r = P([], { name: "GroupArray[" + this._keyToName(n) + "]", deep: !1 }), e.prototype.set.call(this, n, r)), r;
    }
  }), Object.defineProperty(t.prototype, "_removeFromGroupArr", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(n, r) {
      var i = e.prototype.get.call(this, n);
      i.length === 1 ? e.prototype.delete.call(this, n) : (r === i.length - 1 || (i[r] = i[i.length - 1], i[r][this._ogmInfoKey].groupArrIndex = r), i.length--);
    }
  }), Object.defineProperty(t.prototype, "_addItem", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(n) {
      var r = this, i = this._groupBy(n), o = this._getGroupArr(i), a = {
        groupByValue: i,
        groupArrIndex: o.length,
        reaction: Da(function() {
          return r._groupBy(n);
        }, function(u, c) {
          var f = n[r._ogmInfoKey];
          r._removeFromGroupArr(f.groupByValue, f.groupArrIndex);
          var l = r._getGroupArr(u), _ = l.length;
          l.push(n), f.groupByValue = u, f.groupArrIndex = _;
        })
      };
      Object.defineProperty(n, this._ogmInfoKey, {
        configurable: !0,
        enumerable: !1,
        value: a
      }), o.push(n);
    }
  }), Object.defineProperty(t.prototype, "_removeItem", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(n) {
      var r = n[this._ogmInfoKey];
      this._removeFromGroupArr(r.groupByValue, r.groupArrIndex), r.reaction(), delete n[this._ogmInfoKey];
    }
  }), t;
})(xr);
var ds = (
  /** @class */
  function() {
    function e(t, n) {
      Object.defineProperty(this, "base", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }), Object.defineProperty(this, "args", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      }), Object.defineProperty(this, "root", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "closest", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "closestIdx", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: 0
      }), Object.defineProperty(this, "isDisposed", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: !1
      });
      for (var r = this.closest = this.root = t, i = 0; i < this.args.length - 1 && (r = r.get(n[i]), r); i++)
        this.closest = r;
      this.closestIdx = i;
    }
    return Object.defineProperty(e.prototype, "exists", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.assertNotDisposed();
        var t = this.args.length;
        return this.closestIdx >= t - 1 && this.closest.has(this.args[t - 1]);
      }
    }), Object.defineProperty(e.prototype, "get", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        if (this.assertNotDisposed(), !this.exists())
          throw new Error("Entry doesn't exist");
        return this.closest.get(this.args[this.args.length - 1]);
      }
    }), Object.defineProperty(e.prototype, "set", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        this.assertNotDisposed();
        for (var n = this.args.length, r = this.closest, i = this.closestIdx; i < n - 1; i++) {
          var o = /* @__PURE__ */ new Map();
          r.set(this.args[i], o), r = o;
        }
        this.closestIdx = n - 1, this.closest = r, r.set(this.args[n - 1], t);
      }
    }), Object.defineProperty(e.prototype, "delete", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        if (this.assertNotDisposed(), !this.exists())
          throw new Error("Entry doesn't exist");
        var t = this.args.length;
        this.closest.delete(this.args[t - 1]);
        for (var n = this.root, r = [n], i = 0; i < t - 1; i++)
          n = n.get(this.args[i]), r.push(n);
        for (var i = r.length - 1; i > 0; i--)
          r[i].size === 0 && r[i - 1].delete(this.args[i - 1]);
        this.isDisposed = !0;
      }
    }), Object.defineProperty(e.prototype, "assertNotDisposed", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        if (this.isDisposed)
          throw new Error("Concurrent modification exception");
      }
    }), e;
  }()
), vs = (
  /** @class */
  function() {
    function e() {
      Object.defineProperty(this, "store", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "argsLength", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: -1
      }), Object.defineProperty(this, "last", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      });
    }
    return Object.defineProperty(e.prototype, "entry", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        if (this.argsLength === -1)
          this.argsLength = t.length;
        else if (this.argsLength !== t.length)
          throw new Error("DeepMap should be used with functions with a consistent length, expected: " + this.argsLength + ", got: " + t.length);
        return this.last && (this.last.isDisposed = !0), this.last = new ds(this.store, t);
      }
    }), e;
  }()
), Bt = function() {
  return Bt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Bt.apply(this, arguments);
}, ps = function() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  for (var r = Array(e), i = 0, t = 0; t < n; t++)
    for (var o = arguments[t], a = 0, u = o.length; a < u; a++, i++)
      r[i] = o[a];
  return r;
};
function hs(e, t) {
  if (t === void 0 && (t = !1), Me(e))
    throw new Error("computedFn shouldn't be used on actions");
  var n = !1, r = 0, i = typeof t == "boolean" ? { keepAlive: t } : t, o = new vs();
  return function() {
    for (var a = this, u = [], c = 0; c < arguments.length; c++)
      u[c] = arguments[c];
    var f = o.entry(u);
    if (f.exists())
      return f.get().get();
    if (!i.keepAlive && !zn())
      return !n && da().computedRequiresReaction && (console.warn("Invoking a computedFn from outside a reactive context won't be memoized unless keepAlive is set."), n = !0), e.apply(this, u);
    var l, _ = ve(function() {
      return l = e.apply(a, u);
    }, Bt(Bt({}, i), { name: "computedFn(" + (i.name || e.name) + "#" + ++r + ")" }));
    return f.set(_), i.keepAlive || dt(_, function() {
      o.entry(u).delete(), i.onCleanup && i.onCleanup.apply(i, ps([l], u)), l = void 0;
    }), _.get();
  };
}
class Xt {
  constructor(t, n) {
    S(this, "getSource");
    S(this, "transform");
    S(this, "transformCached", cs((t) => this.transform(t)));
    S(this, "getData", hs(
      (t) => this.getDataCore(t, this.transformCached)
    ));
    S(this, "getDataUncached", (t) => this.getDataCore(t, this.transform));
    S(this, "getDataCore", (t, n) => {
      const r = this.getSource(t);
      return r ? n(r) : this.defaultValue;
    });
    this.getSource = t, this.transform = n;
  }
}
class ms extends Xt {
  constructor(n, r) {
    super(n, r);
    S(this, "defaultValue", /* @__PURE__ */ new Map());
  }
}
class ys extends Xt {
  constructor(n, r) {
    super(n, r);
    S(this, "defaultValue", []);
  }
}
class Os extends Xt {
  constructor(n, r) {
    super(n, r);
    S(this, "defaultValue");
  }
}
class Es extends Xt {
  constructor(n, r) {
    super(n, r);
    S(this, "defaultValue", !1);
  }
}
function cr() {
}
class As {
  constructor(t) {
    S(this, "data");
    S(this, "subscriptionDisposer");
    S(this, "onLoad");
    S(this, "onError");
    S(this, "onSuspend");
    S(this, "lazyLoad", () => this.getData().then((t) => {
      si(() => this.data = t), this.subscriptionDisposer = this.subscribe(this.getQuery(t)), this.onLoad(t);
    }).catch((t) => {
      this.onError(t);
    }));
    S(this, "suspend", (t) => () => {
      this.data = t, this.subscriptionDisposer(), this.onSuspend(t);
    });
    const n = {
      onLoad: cr,
      onError: console.error,
      onSuspend: cr,
      ...t
    };
    this.data = n.defaultData, this.onLoad = n.onLoad, this.onError = n.onError, this.onSuspend = n.onSuspend, this.subscriptionDisposer = cr, Yt(this, {
      data: P,
      suspend: C
    }), ci(this, "data", this.lazyLoad), dt(this, "data", this.suspend(n.defaultData));
  }
}
const Ae = {
  /** @returns 0 */
  LOADING: 0,
  /** @returns 1 */
  EMPTY: 1,
  /** @returns 2 */
  ERROR: 2,
  /** @returns 3 */
  LOADED: 3
};
class ws {
  constructor(t) {
    S(this, "dependencies");
    Yt(this, {
      set: C,
      value: ve
    }), this.dependencies = P.map(t.map((n) => [n, Ae.LOADING]));
  }
  set(t, n) {
    this.dependencies.set(t, n);
  }
  get value() {
    return this.resolveCondition();
  }
  /*
   * The order of the condition is important from requirements perspective
   */
  resolveCondition() {
    const t = [...this.dependencies.values()];
    return t.includes(Ae.ERROR) ? Ae.ERROR : t.includes(Ae.EMPTY) ? Ae.EMPTY : t.every((n) => n === Ae.LOADED) ? Ae.LOADED : Ae.LOADING;
  }
}
var Er, wt = Zi;
if (process.env.NODE_ENV === "production")
  Er = wt.createRoot, wt.hydrateRoot;
else {
  var Pn = wt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  Er = function(e, t) {
    Pn.usingClientEntryPoint = !0;
    try {
      return wt.createRoot(e, t);
    } finally {
      Pn.usingClientEntryPoint = !1;
    }
  };
}
class Ns {
  constructor(t, n) {
    S(this, "domId");
    S(this, "component");
    S(this, "root");
    S(this, "logError");
    S(this, "getRoot", (t) => (this.root || (this.root = Er(t)), this.root));
    this.domId = t, this.component = /* @__PURE__ */ nt.jsx(nt.Fragment, {}), this.root = void 0, this.logError = n;
  }
  activate() {
    const t = document.getElementById(this.domId);
    return t && this.getRoot(t).render(/* @__PURE__ */ nt.jsx(to, { logError: this.logError, children: this.component })), this;
  }
  deactivate() {
    return this.root && (this.root.unmount(), this.root = void 0), this;
  }
}
export {
  ys as ArrayIndex,
  Xt as BaseIndex,
  As as BaseRetriever,
  Ns as BaseWidget,
  Es as BooleanIndex,
  ws as Condition,
  Ae as DataCondition,
  to as ErrorBoundary,
  ms as MapIndex,
  Os as ObjectIndex
};
